import { ReactElement } from 'react';
import { CircularIconContainer } from './style';

export interface CircularIconProps {
	icon?: ReactElement;
	size: number;
}

export function CircularIcon({ icon, size }: CircularIconProps) {
	return <CircularIconContainer size={size}>{icon}</CircularIconContainer>;
}
